<br/>
<div class="container">
    <!--
    <div class="row mx-auto w-100">
        <div class="alert alert-success w-100" role="alert">
            All systems are operational
          </div>
    </div>
    -->
    <app-system-wide-message></app-system-wide-message>
    <div class="system-wide-message alert alert-danger alert-dismissible fade show" role="alert" *ngIf="realtime == false">
      <div>There was an error retrieving the real-time data, please try refreshing.</div>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <app-omni-search></app-omni-search>

    <div class="row mx-auto w-100" *ngIf="overview.length > 0">
      <span class="badge">Overview </span>
        <ul class="list-group w-100">
            <li class="list-group-item" *ngFor="let mode of overview" ><a [href]="'system/' + mode.url" > {{ mode.mode }}   <span class="float-right badge" [ngClass]="mode.class"> {{ mode.status }} <span class="badge badge-light" *ngIf=" mode.count > 1"> {{ mode.count }}</span> </span></a></li>
        </ul>
    </div>

    <div class=" mx-auto w-100 mt-2" *ngIf="rss.length > 0">
      <span class="badge">News Releases </span>
      <ul class="list-group w-100">
        <li class="list-group-item" *ngFor="let article of rss">
          <div><a [attr.href]="article.link"> {{ article.title }} </a></div>
          <span class="badge"> {{ article.pubDate }} </span>
        </li>
      </ul>
    </div>

    <div class=" mx-auto w-100 mt-2" *ngIf="rss.length < 1 && overview.length < 1">
      <div class="card" style="width: 100%;">
        <div class="card-body">
          <h5 class="card-title">Uh oh...</h5>
          <p class="card-text">Looks like we are having some techinical issues. Try refreshing if the problem persists try reaching out to our customer service.</p>
          <a href="https://twitter.com/septa_social" class="btn btn-primary">Checkout SEPTA Social</a>
        </div>
      </div>
    </div>

    <br />
</div>
<app-main-footer></app-main-footer>
